module.exports = __webpack_public_path__ + "static/media/joloj.959c52ea.gif";